export const formatDate = (date: Date | string | number) => {
  const dateObj =
    typeof date === 'string' || typeof date === 'number'
      ? new Date(date)
      : date;
  const now = new Date();
  const diffInHours = (now.getTime() - dateObj.getTime()) / (1000 * 60 * 60);

  if (diffInHours < 24) {
    return dateObj.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });
  } else if (diffInHours < 24 * 7) {
    return dateObj.toLocaleDateString([], { weekday: 'short' });
  }
  return dateObj.toLocaleDateString([], { month: 'short', day: 'numeric' });
};

export {
  getAssistantLogoUrl,
  shouldShowLocalAssistantIconFallback,
} from './assistantLogo';
